<template>
    <div class="course_main">
        <div v-if="!isWeixinBrowser()" class="navigation" :style="{height:getNavCount()+'px'}">
            <div :style="{height:getStateHeight()+'px'}"></div>
            <div class="left" @click="goBack"><i class="icon-thin_back"/></div>
            <div class="title">课程介绍</div>
            <div class="clear"></div>
        </div>

        <div v-if="!isWeixinBrowser()" :style="{'padding-top':getNavCount()+'px'}"></div>

        <div v-if="objLesson != null">
            <div class="intro_content">
                <pre id="div_intro_content" class="content">{{objLesson.courseIntroduction}}</pre>
            </div>

            <div class="view_time margin_top40" v-if="!isEmpty(objLesson.watchFrequency)">
                <div class="backgroud_title">观看Tips</div>
                <div class="backgroud_content">
                    <pre>{{objLesson.watchFrequency}}</pre>
                </div>
            </div>

            <div class="bottom_space"></div>
        </div>

    </div>
</template>

<script>
    export default {
        data() {
            return {
                lessonId: 0,
                objLesson: null,
            }
        },
        methods: {
            getStateHeight: function () {
                return this.isWeixinBrowser() ? 15 : this.getCount(this.$store.state.statusheight);
            },
            getNavCount: function () {
                return this.getStateHeight() + 44;
            },
        },
        beforeCreate() {
            let vLessonId = parseInt(this.$route.query.lessonId);
            let url = "englishProgram/getLessonHomeInfo/" + vLessonId;
            let that = this;
            this.$axios.get(url).then((response) => {
                that.lessonId = vLessonId;
                that.objLesson = response.data;
            }).catch(function (error) {
                window.console.log(error)
            });
        },
    }
</script>

<style scoped>
    .navigation {
        position: fixed;
        width: 100%;
        z-index: 998;
        background-color: white;
    }

    .course_main {
        background-color: white;
    }
    .course_main .left {
        color: #333333;
    }
    .course_main .title {
        color: #333333;
        font-size: 18px;
    }

    .course_main .name {
        width: calc(100% - 30px);
        margin-left: 15px;
        margin-right: 15px;
        padding-top: 20px;
        color: #333333;
        font-size: 20px;
        font-weight: bold;
        word-wrap: break-word;
        word-break: normal;
    }
    .course_main .subject, .course_main .produced {
        margin-top: 5px;
        margin-left: 15px;
        margin-right: 15px;
        font-size: 15px;
        color: #333333;
    }
    .course_main .subject span, .course_main .produced span {
        color: #999;
    }

    .view_time {
        width: calc(100% - 30px);
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 20px;
        color: #333333;
        font-size: 15px;
        text-align: left;
    }

    .intro_content {
        text-align: left;
        margin-left: 15px;
        margin-right: 15px;
    }
    .intro_content .content {
        color: #333333;
        font-size: 16px;
        line-height: 25px;
        text-align: left;
    }

    pre {
        white-space:pre-wrap;
        white-space:-moz-pre-wrap;
        white-space:-pre-wrap;
        white-space:-o-pre-wrap;
        word-wrap:break-word;
    }

    .course_main .backgroud_title {
        margin-top: 5px;
        color: #333333;
        font-size: 16px;
    }
    .course_main .backgroud_content {
        margin-top: 10px;
        color: #333333;
        font-size: 16px;
    }
    .bottom_space {
        height: 100px;
    }
    .margin_top40 {
        margin-top: 40px;
    }

</style>